// One-tap answer chip for the checkout questions.
export const Choice = ({ on, label, onClick, testid }) => (
  <button type="button" data-testid={testid} onClick={onClick}
          className={`text-sm px-4 py-2 border transition-colors duration-200 focus:ring-2 focus:ring-brass ${
            on ? "border-brass bg-petal/20 text-ink" : "border-brass-light text-muted hover:text-ink hover:border-brass"}`}>
    {label}
  </button>
);

// Compact country-code picker; inline width because the global `.field` rule sets width:100%.
export const DialSelect = ({ value, onChange, list, testid, label }) => (
  <select className="field text-sm" style={{ width: 108, flexShrink: 0 }} data-testid={testid} value={value} aria-label={label}
          onChange={(e) => onChange(e.target.value)}>
    {list.map((c) => <option key={c.code} value={c.code}>{`${c.flag} ${c.dial}`}</option>)}
  </select>
);

// Phone input with its country-code picker on the left.
export const PhoneField = ({ dialTestid, dialLabel, list, country, onCountry, inputProps }) => (
  <div className="flex gap-2">
    <DialSelect testid={dialTestid} label={dialLabel} list={list} value={country} onChange={onCountry} />
    <input className="field flex-1 min-w-0" type="tel" {...inputProps} />
  </div>
);
